module.exports = __webpack_public_path__ + "media/images/emblems/Termen-coat_of_arms-2fc2a4f8212da354e9700b732c3878dd.svg";